var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"v-card mb-4"},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_c('v-card-text',{staticClass:"py-6"},[_c('v-container',[_vm._t("header"),_vm._t("body")],2)],1),_c('v-card-actions',[_c('v-spacer'),_vm._t("buttons")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }